/*
 * Resilia compounds — mobile carousel arrows. Swiping is native scroll-snap; arrows step one card and wrap around.
 */
(() => {
  if (window.rnCompoundsReady) return;
  window.rnCompoundsReady = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const arrow = event.target.closest('[data-cmpd-prev], [data-cmpd-next]');
    if (!arrow) return;

    const track = arrow.closest('.rn-cmpd').querySelector('[data-cmpd-track]');
    const cards = [...track.children];
    if (!cards.length) return;

    const step = cards[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
    const current = Math.round(track.scrollLeft / step);
    const last = cards.length - 1;
    const next = arrow.hasAttribute('data-cmpd-next')
      ? (current >= last ? 0 : current + 1)
      : (current <= 0 ? last : current - 1);

    track.scrollTo({ left: next * step, behavior: 'smooth' });
  });
})();
